export enum SystemEndPoint {
  Unread = 'system/set/unread/',
  ReadAll = 'system/set/read/',
  GetServerId = 'system/server/id/',
  GetAutoSignStatus = 'system/autosign/status/',
  CheckReplicationSystem = 'system/rplobjects/check/',
  GetUserId = 'system/user/id/',
  AddComment = 'system/comment/add/',
  EditComment = 'system/comment/edit/',
  DeleteComment = 'system/comment/del/',
  GetCommentsMarkdown = 'comments/comments/get/',
  GetDeadline = 'system/get/deadline/',
  GetWorkDaysDiff = 'system/workdaysdiff/',
  GetTimezone = 'system/server/timezone/',
  GetGuiElements = 'gui/elements/get/',
}
